import get from 'lodash/get';
import React from 'react';

import { Anchor } from 'common/css_global/desktop/utils.css';
import { ProductMicrodata } from 'components/PageSpecificMetadata/Microdata/ProductMicrodata';
import { fontFamilies } from 'components/UI/Font';
import VerticalSpacer from 'components_common/VerticalSpacer/VerticalSpacer';
import { formatPrice } from 'helpers/stringFormatters';
import { useUrlBuilder } from 'hooks/useUrlBuilder';
import { Product } from 'models/product';
import { getProductSearchCategories } from 'shared/helpers/product';

export const ProductNotFound: React.FC<{
  countryCode: string;
  currencyIso?: string;
  freeShipping: boolean;
  product: Product;
}> = ({ countryCode, currencyIso, freeShipping, product, product: { model, price } }) => {
  const { localized, withTrailingSlash } = useUrlBuilder();

  const mediumImage: string | null = get(product, 'images[0].medium', null);
  const searchCategories = getProductSearchCategories(product);
  const searchCategory = searchCategories[searchCategories.length - 1];
  const searchCategoryUrl = withTrailingSlash(localized(searchCategory.url));

  const finalButtonText = searchCategory?.name || 'Home';
  const finalButtonUrl = searchCategoryUrl || localized();

  return (
    <>
      <div className="product_not_found" data-cy="product-not-found">
        <VerticalSpacer height="50px" />
        <div className="apology desktop">Sorry, this product is out of stock. Click here to find more</div>

        <div className="apology mobile">Sorry, this product is out of stock.</div>
        <VerticalSpacer className="mobile" height="5px" />
        <div className="apology mobile">Tap to find more from</div>
        <VerticalSpacer height="30px" />
        <div id="button-wrapper">
          <Anchor
            backgroundColor="#000000"
            border="none"
            data-cy="button-to-category"
            fontSize="15px"
            height="44px"
            href={finalButtonUrl}
            letterSpacing="0"
            padding="11px"
            radius="5px"
            textTransform="none"
          >
            {finalButtonText}
          </Anchor>
        </div>
      </div>

      <ProductMicrodata
        countryCode={countryCode}
        currencyIso={currencyIso}
        freeShipping={freeShipping}
        image={mediumImage}
        isOutOfStock
        price={formatPrice(price.reducedAfterTax)}
        productName={model}
      />

      <style jsx>{`
        #button-wrapper {
          text-align: center;
          margin: 0 auto;
          padding: 10px;
          width: 335px;
        }

        .apology {
          font-family: ${fontFamilies.light};
          font-size: 15px;
          text-align: center;
        }

        @media (min-width: 1024px) {
          .apology {
            line-height: 18px;
          }
        }
      `}</style>
    </>
  );
};
